<template>
  <div :class="{ 'has-error': validacao.$error }" class="form-group">
    <label v-if="exibeLabel">
      {{ label }} <sup>{{ labelSup }}</sup>
    </label>
    <input
      :id="id"
      v-mask="mascara"
      :data-test-id="`input-${id}`"
      :name="id"
      :placeholder="placeholder"
      :readonly="somenteLeitura"
      :value="valor"
      type="text"
      :class="{ 'form-control': true, 'input-sm': tamanho === 'sm' }"
      @input="atualizar($event.target)"
      @blur="$emit('blur', $event.target)"
    />
    <div v-if="validacao.$dirty" class="help-block">
      <slot name="mensagensValidacao" />
    </div>
  </div>
</template>

<script>
import AwesomeMask from 'awesome-mask'

import { campoMixin } from '@/mixins/CampoMixin'

export default {
  name: 'CampoGenerico',
  directives: { mask: AwesomeMask },
  mixins: [campoMixin],
  props: {
    label: {
      type: String,
      default: '',
      require: true,
    },
    id: {
      type: String,
      default: 'campoGenerico',
      require: true,
    },
    mascara: {
      type: String,
      default: '',
    },
    tamanho: {
      type: String,
      default: '',
    },
  },
}
</script>
